module.exports = __webpack_public_path__ + "media/images/athletes/3587-366ef6916e84221c49c54837187479fa.png";